import React, { useContext } from 'react';

import { ApplicationUIContext, Table } from '@yuhuinc/ui-library';
import { Typography, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';

import { getTranslatedString } from 'helpers/i18n';

import { CurrentApplicationContext } from '../../ApplicationOverview';

const { Title, Link } = Typography;

const COLUMNS = [
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.documents.applicant'
    ),
    dataIndex: 'applicant',
    key: 'applicant',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.documents.documentsCount'
    ),
    dataIndex: 'documentsCount',
    key: 'documentsCount',
  },
];

const APPLICANT_DOCUMENTS_COLUMNS = [
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.documents.name'
    ),
    dataIndex: 'name',
    key: 'name',
    render(value) {
      return <Link href="#">{value}</Link>;
    },
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.documents.type'
    ),
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.documents.addedAt'
    ),
    dataIndex: 'addedAt',
    key: 'addedAt',
  },
  {
    key: 'actions',
    render() {
      return <Button type="link" icon={<EyeOutlined />} />;
    },
  },
];

const DUMMY_DOCUMENTS = [
  {
    key: 1,
    name: 'drivers-licence.jpg',
    type: 'Vehicle',
    addedAt: '2022-06-05',
  },
  {
    key: 2,
    name: 'paystubsAfsun.pdf',
    type: 'Income',
    addedAt: '2022-06-05',
  },
];

const Documents = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const application = useContext(CurrentApplicationContext);
  const dataSource = application.cotenants.map((cotenant) => ({
    key: cotenant.id,
    applicant: cotenant.full_name,
    documentsCount: 0,
    documents: [],
  }));

  return (
    <>
      <Title level={isMobile ? 4 : 5}>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.review.documents'
        )}
      </Title>
      <Table
        dataSource={dataSource}
        columns={COLUMNS}
        hideActionAndSearch
        size={isMobile ? 'middle' : 'small'}
        scroll={{
          x: isMobile,
        }}
        pagination={{ hideOnSinglePage: true }}
        rowExpandable={(record) => record.documents.length > 0}
        expandedRowRender={(record) => (
          <Table
            dataSource={record.documents}
            columns={APPLICANT_DOCUMENTS_COLUMNS}
            hideActionAndSearch
            size={isMobile ? 'middle' : 'small'}
            scroll={{
              x: isMobile,
            }}
            pagination={{ hideOnSinglePage: true }}
          />
        )}
      />
    </>
  );
};

export default Documents;
